module.exports = __webpack_public_path__ + "static/img/dongbeimajiang.9be3d7b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/static/gameImg/dongbeimajiang.jpg
// module id = 9dt9
// module chunks = 0